import React from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import { buttonify } from '../../lib/form';
import Icon from '../icon/icon';
import Day from './day';
import i18n from './i18n';

const {
	bool, string, shape, func, arrayOf
} = propTypes;

const Calendar = function (props) {
	const __ = mergeI18n(props.language, i18n);
	document.title = `${__.titleStem} - ${__.pageTitle}`;

	const weeks = _.chunk(props.calendarDays.map((day, index) => (
		<Day key={index} {...day} onSelectDate={props.onSelectDate} />
	)), 7)
		.map((days, index) => <tr key={index}>{days}</tr>);

	/* eslint jsx-a11y/no-static-element-interactions: 0 */
	return (
		<div id='calendar'>
			<div className='calendar-header'>
				<span
					role='button'
					tabIndex='0'
					aria-label={__.lastMonthLabel}
					onClick={props.onClickLastMonth}
					onKeyPress={buttonify(props.onClickLastMonth)}
					style={{ 'visibility': props.availabilityForLastMonth ? 'visible' : 'hidden' }}
					className='month-button prev'
				>
					<Icon name='MdChevronLeft' align='sub' />
				</span>
				<span className='month-label'>{__.calendarHeader(props.selectedMonth)}</span>
				<span
					role='button'
					tabIndex='0'
					aria-label={__.nextMonthLabel}
					onClick={props.onClickNextMonth}
					onKeyPress={buttonify(props.onClickNextMonth)}
					style={{ 'visibility': props.availabilityForNextMonth ? 'visible' : 'hidden' }}
					className='month-button next'
				>
					<Icon name='MdChevronRight' align='sub' />
				</span>
			</div>
			<table>
				<tbody>
					<tr className='header'>{__.days.map(day => <th className='day-header' key={`calendar-day-${day}`}>{day}</th>)}</tr>
					{weeks}
					<tr className='spacer'>{__.days.map(day => <td key={`spacer-day${day}`} />)}</tr>
				</tbody>
			</table>
			<div className='calendar-legend'>
				<span className='availability' />
				<span>{__.legendText}</span>
			</div>
		</div>
	);
};

Calendar.propTypes = {
	language: string.isRequired,
	selectedMonth: string.isRequired,
	calendarDays: arrayOf(shape({
		date: string.isRequired,
		timeSlots: arrayOf(shape({
			startDatetime: string.isRequired,
			endDatetime: string.isRequired
		})),
		isCurrentMonth: bool,
		isSelected: bool
	})),
	availabilityForLastMonth: bool.isRequired,
	availabilityForNextMonth: bool.isRequired,
	onSelectDate: func.isRequired
};

export default Calendar;
